// Admin Panel V2 - New version without react-admin
import AdminApp from "./admin-v2/App";

function App() {
  return <AdminApp />;
}

export default App;
